let currentRequest = null,
    notAllDisplayed = true;
let lazySettings = window.lazy_settings;
let elementApiUrl = window.element_api_url;
let lazyOffset = 1;

const errorMessage = document.querySelector('.js-lazy-error');
const lazyWrapper = document.querySelector('.js-lazy-wrapper');
let lazyList = lazyWrapper.querySelector('.js-lazy-list');
const lazyPreloader = document.querySelector('.js-lazy-preloader');
const WD = 120;
const ready = (func) => {
    if (document.readyState !== 'loading') {
        func();
    } else {
        document.addEventListener('DOMContentLoaded', func);
    }
};
/* eslint-disable */


var oldValue = 0
var newValue = 0

ready(() => {

    //document.addEventListener("touchmove", ScrollStart, false);
    document.addEventListener("scroll", Scroll, false);

    function Scroll() {       
        newValue = window.pageYOffset;          
        if (oldValue < newValue) {
            if (currentRequest === null && notAllDisplayed === true) {
                currentRequest = $.ajax({
                    url: elementApiUrl,
                    method: 'GET',
                    data: {
                        offset: lazyOffset,
                        settings: lazySettings,
                    },
                    beforeSend: () => {
                        lazyPreloader.style.display = 'block';
                    },
                })
                .always(() => {
                    lazyPreloader.style.display = 'none';
                    currentRequest = null;
                })
                .done((returned) => {
                    lazyOffset++;
                    let html = '';
                    returned.data.forEach((element) => {                                            
                        html += element.html;
                    });        
                    lazyList.innerHTML += html;
                    if (!returned.data.length) {
                        notAllDisplayed = false;
                    }
                    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                        return new bootstrap.Tooltip(tooltipTriggerEl)
                    })
                })
                .fail(() => {
                    errorMessage.textContent = 'Unable to retrieve articles.';
                });
            }
        }
        oldValue = newValue;
    };
});


/* eslint-enable */
/* eslint-disable */

if (module.hot) {
    module.hot.accept();
}
/* eslint-enable */
